import React from "react";
import { useParams } from "react-router-dom";
import { PageHeader, Spinner } from "../../components/common";
import { NoAccessPanel } from "../../components/FeatureGate";
import { PoliciesManager } from "../../components/policies/PoliciesManager";
import { usePolicyAccess } from "../../lib/policies";
import { Badge } from "../../components/ui/badge";

/** Phase 218 — Admin → Policies: the company policy library (what the Super Admin allowed). */
export default function PoliciesPage() {
  const { code } = useParams();
  const { loaded, access, reload } = usePolicyAccess(code);
  if (!loaded) return <Spinner />;
  if (!access?.library_visible) return <NoAccessPanel what="Policies" testId="policies-no-access" />;
  const granted = [access.can_upload && "Upload", access.can_edit && "Edit", access.can_assign && "Assign", access.can_delete && "Delete & restore"].filter(Boolean);
  return (
    <div data-testid="policies-page">
      <PageHeader title="Policies" subtitle="Company policies your staff must read and sign — upload PDFs, keep versions, choose who must sign and track sign-off">
        <div className="flex flex-wrap gap-1" data-testid="policies-rights">
          <Badge variant="secondary" className="text-[10px]">View</Badge>
          {granted.map((g) => <Badge key={g} variant="secondary" className="text-[10px]">{g}</Badge>)}
          {granted.length === 0 && <Badge variant="outline" className="text-[10px]">Read-only (granted by the Super Admin)</Badge>}
        </div>
      </PageHeader>
      <PoliciesManager code={code} rights={access} onChanged={reload} />
    </div>
  );
}
